export const PopoverAnimation = {
    initial: { opacity: 0, y: 5 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 5 },
    transition: { type: 'tween', duration: 0.125 },
};
